import { useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import AppRoutes, { HOME_ROUTE } from 'config/AppRoutes';
import { allConditionalSteps, getActiveSteps } from 'config/steps';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { AnswersSelector, StepParamsSelector } from 'store/selectors';
import checkIfAllRequiredAnswersAreDefined from 'utils/checkIfAllRequiredAnswersAreDefined';

export default function useAnswerSanityCheck() {
  const navigate = useNavigate();
  const location = useLocation();
  const stepParams = useSelector(StepParamsSelector);
  const answers = useSelector(AnswersSelector);
  const toast = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    const steps = getActiveSteps(allConditionalSteps, stepParams);
    const currentRoute = location.pathname;

    // NOTE: We don't perform the sanity check on the estimate page because
    // we fetch data on that page, once it is fetched, it is put inside our redux store
    // which means that the check would be performed before the fetch and thus a false negative would occur
    // Nor in the Thanks page, as we might be there with the SME_CONTACT form, where all datas are not used
    const pagesWithNoSanityCheck = [AppRoutes.ESTIMATE, AppRoutes.THANKS];
    if (pagesWithNoSanityCheck.includes(currentRoute)) return;

    // lets update sentry context each time answers changes
    Sentry.setContext('answers', answers);

    if (!checkIfAllRequiredAnswersAreDefined(steps, currentRoute, answers)) {
      toast({
        title: t('warning.stateCheck.title'),
        description: `${t('warning.stateCheck.description')}`,
        status: 'info',
        position: 'top',
        duration: 6000,
        isClosable: true,
      });
      navigate(HOME_ROUTE);
    }
  }, [location.pathname, answers, toast, navigate, t, stepParams]);
}
